<template>
  <div-box>
    <wallet-head show_type="2" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      url="/api/v1/user/invest" :data="{}">
      <div-width width='70vw'>
        <div-tab tab='stick'>
          <van-tabs @click="onClick" v-model='activex' background="#0F0F0F" color='#CEB082'>
            <van-tab>
              <template #title>
                <div-padding>
                  <div-text size='4vw' :color='activex == 0 ? `#fff` : `#999`'>{{ $t('贡献') }}</div-text>
                </div-padding>
              </template>
            </van-tab>
            <van-tab>
              <template #title>
                <div-padding>
                  <div-text size='4vw' :color='activex == 1 ? `#fff` : `#999`'>{{ $t('复投') }}</div-text>
                </div-padding>
              </template>
            </van-tab>
          </van-tabs>
        </div-tab>
      </div-width>
      <div-padding padding="3vw">
        <div-card bg='#242424' padding='3vw 3vw 0 3vw'>
          <div-flex br>
            <div-card :bg='activey == index ? "linear-gradient(180deg, #FFD791 0%, #F4BB67 100%)" : "#433B2E"'
              width="20vw" margin="0 0 3vw 0" height="18vw" padding='3vw 0vw' v-for="(item, index) in num_list"
              :key="index" @click="opt(index, item.amount)">
              <div-text :color='activey == index ? "#242424" : "#fff"' size='4.5vw' center>{{ item.amount }}</div-text>
              <div-text :color='activey == index ? "#242424" : "#fff"' size='3vw' center>USDT</div-text>
            </div-card>
          </div-flex>
        </div-card>
        <div-padding padding="4vw 0">
          <div-flex>
            <div-flex left>
              <div-img width='4vw' height='4vw'>
                <img src="../../assets/img/zujian@2x.png" alt="">
              </div-img>
              <div-width width='1vw' />
              <div-text color='#fff' size='4vw'>{{ $t('贡献数量') }}</div-text>
            </div-flex>
            <div-text color='#CEB082' align="right" size='4vw'>
              {{ $t('可用') }}ACT：{{ info.act }}
            </div-text>
          </div-flex>
        </div-padding>
        <div-flex>
          <div-text color='#fff' size='4vw'>最小贡献数量：{{ set_info.min_amount }}</div-text>
          <div-text color='#fff' size='4vw'>仅可贡献{{ set_info.min_amount }}的倍数</div-text>
        </div-flex>
        <div-height height='3vw' />
        <div-flex>
          <div-input>
            <div-card bg="#242424" padding='3vw' radius='2vw'>
              <van-field :border='false' type="number" @input="get_num(num)" clearable v-model='num'
                :placeholder='$t("请输入数量")'>
              </van-field>
            </div-card>
          </div-input>
          <div-width width='3vw' />
          <div-img width='12vw' height='12vw'>
            <img src="../../assets/img/jia@2x.png" @click="num = num * 1 + 100" alt="">
          </div-img>
        </div-flex>
        <div-height height='3vw' />
        <div-text color='#CEB082' size='4vw' v-if="activex == 0">
          {{ $t('应支付') }}：{{ num }}USDT
        </div-text>
        <!-- <div-text color='#CEB082' size='4vw' v-if="activex==1">
          {{$t('应支付')}}：{{num_info.usdt_amount}} USDT+{{num_info.card_amount}}卡牌
        </div-text>
        <div-padding padding="0 20vw" v-if="activex==1">
          <div-text color='#CEB082' size='4vw'>或
          </div-text>
        </div-padding> -->

        <div-text color='#CEB082' size='4vw' v-if="activex == 1">
          {{ $t('应支付') }}：{{ num_info.act_amount }} ACT+{{ num_info.card_amount }}卡牌
        </div-text>
        <div-height height='3vw' />
        <div-btn v-if="activex == 0" @click.native="tran()" radius="3vw"
          bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
          <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
        </div-btn>
        <div-btn v-if="activex == 1" @click.native="one()" radius="3vw"
          bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
          <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
        </div-btn>
        <div-padding padding="4vw 0">
          <div-flex left>
            <div-img width='4vw' height='4vw'>
              <img src="../../assets/img/zujian@2x.png" alt="">
            </div-img>
            <div-width width='1vw' />
            <div-text color='#fff' size='4vw'>{{ $t('我的贡献') }}</div-text>
          </div-flex>
        </div-padding>

        <div-card bg="#242424" v-for="(item, index) in list" :key="index" padding='3vw' radius='2vw' margin="0 0 3vw 0">
          <div-flex>
            <div-text two color='#CEB082' bold size='4.5vw'>
              {{ item.total_amount }}
            </div-text>
            <div-text color='#fff' size='4vw'>{{ item.type == 1 ? $t("贡献") : $t("复投") }}</div-text>
          </div-flex>
          <div-height height='2vw' />
          <div-text color='#999' size='3.5vw'>{{ item.created_at }}</div-text>
        </div-card>
      </div-padding>
    </vant-up-down>

    <van-popup class="popupcode" v-model="show_code" style="width: 76%;top:40%;" closeable>
      <div class="content">
        <p>{{ $t('交易密码') }}</p>
        <!-- <div-flex>
          <div-card :bg='activetype==index?"linear-gradient(180deg, #FFD791 0%, #F4BB67 100%)":"#433B2E"' width="30vw" padding='3vw 0vw' margin="0 3vw" v-for="(item,index) in opt_list" :key="index" @click="opt_type(index,item.type)">
            <div-text :color='activetype==index?"#242424":"#fff"' size='4vw' center>{{$t(item.name)}}</div-text>
          </div-card>
        </div-flex> -->

        <!-- <div-height height='5vw' /> -->
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading" @click="futou">{{
          $t('确定') }}</van-button>
      </div>
    </van-popup>

  </div-box>
</template>

<script>
export default {
  data() {
    return {
      activex: 0,
      activey: 100,
      activetype: 0,
      type: 2,
      num_list: [],
      opt_list: [
        { name: "USDT+卡牌", type: 2 },
        { name: "ACT+卡牌", type: 3 },
      ],
      list: [],
      num: "",
      info: {},
      loading: false,
      show_code: false,
      password: "",
      address: "",
      set_info: {},
      num_info: {},
    }
  },
  created() {
    this.get_list()
    this.get_info()
    this.up_down()
  },
  methods: {
    get_num(num) {
      this.$get({
        url: "/api/v1/user/reinvest",
        data: {
          amount: num || 0,
        },
        success: (res) => {
          this.num_info = res.data
        },
        tip: () => { },
      })
    },
    opt_type(index, type) {
      this.activetype = index
      this.type = type
    },
    one() {
      if (!this.num) return this.$toast(this.$t("请输入复投数量"))
      this.show_code = true
    },
    futou() {
      if (!this.num) return this.$toast(this.$t("请输入复投数量"))
      if (!this.password) return this.$toast(this.$t("请输入交易密码"))
      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.loading = true
      this.$post({
        url: "/api/v1/user/reinvest",
        data: {
          amount: this.num,
          pay_type: 3, //this.type,
          trade_password: this.password,
        },
        success: (res) => {
          this.show_code = false
          this.$toast(res.data)
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.show_code = false
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
      })
    },

    tran() {
      if (!this.num) return this.$toast(this.$t("请输入贡献数量"))
      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.$toast.loading({
        duration: 0,
        overlay: true
      })
      this.loading = true
      let that = this
      that.$nextTick(() => {
        console.log("1", that.address)
        that.blockFun
          .transfer("usdt", that.num, that.address, "ether", false)
          .then((hash) => { that.pay(hash) }).catch((err) => {
            that.loading = false
            that.$toast.fail(that.$t(err.msg))
          })
      })
    },
    pay(hash) {
      this.$post({
        url: "/api/v1/user/invest",
        data: {
          amount: this.num,
          hash: hash,
        },
        success: (res) => {
          this.$toast(res.data)
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.$toast.clear()
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
      })
    },
    get_info() {
      this.$get({
        url: "/api/v1/user/invest/setting",
        success: (res) => {
          this.address = res.data.address
          this.set_info = res.data
        },
        tip: () => { },
      })
      this.$get({
        url: "/api/v1/user/info",
        success: (res) => {
          this.info = res.data
        },
        tip: () => { },
      })
    },
    onClick() {
      this.get_list()
    },
    opt(index, amount) {
      this.activey = index
      this.num = amount
    },
    get_list() {
      this.$get({
        url: "/api/v1/user/invest/amount",
        data: {
          type: this.activex + 1,
        },
        success: (res) => {
          this.num_list = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped>
/deep/.van-field__control {
  color: #fff !important;
  font-size: 4vw !important;
}

.popupcode {
  background: #242424;
  box-shadow: 0px 3px 10px 1px rgba(255, 236, 209, 0.13);

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;

    >p {
      width: 100%;
      text-align: center;
      font-size: 15px;
      font-weight: 550;
      padding: 5px 0 30px;
    }

    /deep/.van-cell {
      background: #0f0f0f;
      border-radius: 6px;
      margin-bottom: 15px;
      padding: 3vw;

      .van-cell__title {
        width: 4em;
        color: #fff;
      }

      .van-field__control {
        color: #fff;
      }
    }

    .van-button {
      margin-top: 15px;
    }
  }
}
</style>